import * as yup from 'yup';

import { EMAIL_PATTERN } from '@/constants/patterns';

import { TranslatorFunction } from '@/types/i18n';

import { isAbove18 } from '@/utils/validation';

export const getValidationSchema = (t: TranslatorFunction) => {
  return yup.object().shape({
    firstName: yup
      .string()
      .required(t('page.addAdultDetail.form.firstName.error.required')),
    middleName: yup.string(),
    lastName: yup
      .string()
      .required(t('page.addAdultDetail.form.lastName.error.required')),
    birthday: yup
      .string()
      .required(t('page.addAdultDetail.form.birthday.error.required'))
      .test(
        'is-above-18',
        t('page.addAdultDetail.form.birthday.error.notAdult'),
        value => (value ? isAbove18(value) : true),
      ),
    email: yup
      .string()
      .required(t('page.addAdultDetail.form.email.error.required'))
      .matches(
        new RegExp(EMAIL_PATTERN),
        t('page.addAdultDetail.form.email.error.incorrectFormat'),
      ),
    phoneCode: yup.string(),
    phoneNumber: yup
      .string()
      .matches(
        /^\d{7}$/,
        t('page.addAdultDetail.form.phoneNumber.error.invalidFormat'),
      ),
    relationship: yup
      .string()
      .required(t('page.addAdultDetail.form.relationship.error.required')),
  });
};

export type AddAdultDetailFormType = yup.InferType<
  ReturnType<typeof getValidationSchema>
>;

export const DEFAULT_ADULT_DETAIL_FORM_VALUES: AddAdultDetailFormType = {
  firstName: '',
  middleName: '',
  lastName: '',
  birthday: '',
  email: '',
  phoneCode: '',
  phoneNumber: '',
  relationship: '',
};
